import { DeviceDto } from "@lib/dtos/monitoring/device.dto";

export enum DeviceType {
  PM_BASE = "PM_BASE",
  PM_M_A = "PM_M_A",
  PM_M = "PM_M",
  PM_SP02 = "PM_SP02",
  CS_A = "CS_A",
  CS_BASE = "CS_BASE",
  CS_LICENCE_M300 = "CS_LICENCE_M300",
  CS_LICENCE = "CS_LICENCE",
  TLM_BASE = "TLM_BASE",
  KVM_T_P2P = "KVM_T_P2P",
  KVM_T_IP = "KVM_T_IP",
  KVM_R_IP = "KVM_R_IP",
  D = "D",
  D_A = "D-A",
  UTI = "UTI",
  KVM_A = "KVM-A",
  KVM_R_P2P = "KVM-R-P2P",
  PM_SPO2 = "PM-SpO2",
  TLM_A = "TLM-A",
  TLM_SPO2 = "TLM-SpO2",
}

const DEVICE_TYPE_SET = new Set(Object.values(DeviceType));

export function isDeviceType(type: unknown): type is DeviceType {
  return DEVICE_TYPE_SET.has(type as DeviceType);
}

export class Device extends DeviceDto {
  constructor(
    matNr: string,
    name: string,
    isAvailable: boolean,
    description: string,
    deviceType: DeviceType,
    piSheetURL: string,
    configurationURL: string,
    productImageCantoID: string,
    countries: string[],
    productFamily?: string,
  ) {
    super();
    this.matNr = matNr;
    this.name = name;
    this.isAvailable = isAvailable;
    this.description = description;
    this.deviceType = deviceType;
    this.piSheetURL = piSheetURL;
    this.configurationURL = configurationURL;
    this.productImageCantoID = productImageCantoID;
    this.countries = countries;
    this.productFamily = productFamily;
  }
}
